// Centralised route definitions — single source of truth for navigation
export const ROUTES = {
  HOME: '/',
  TESTS: '/tests',
  TEST_DETAIL: '/tests/:id',
  PACKAGES: '/packages',
  PACKAGE_DETAIL: '/packages/:id',
  SPECIALS: '/specials',
  MEMBERSHIP: '/membership',
  ABOUT: '/about',
  BLOG: '/blog',
  BLOG_ARTICLE: '/blog/:slug',
  FAQ: '/faq',
  SUPPORT: '/support',
  // The reference merges our /support and /faq into one Help page.
  // SUPPORT stays as the ticket flow Help links out to, and /faq
  // redirects here.
  HELP: '/help',
  CENTRES: '/centres',
  DOCTORS: '/doctors',
  PRIVACY: '/privacy',
  // The v5 reference folds privacy, terms and refunds into one page with
  // three tabs (#privacy / #terms / #refunds). /privacy redirects here.
  // APP_PRIVACY below is deliberately NOT touched — it is the URL printed
  // on the store listings.
  LEGAL: '/legal',
  // Bare privacy policy (no navbar / footer) — submitted to Play Store
  // & App Store as the mobile app's privacy URL.
  APP_PRIVACY: '/app-privacy',
  // Smart app-download link — the URL the printed QR code encodes.
  // Sends Android to Play Store and iPhone to the App Store. Keep the
  // path short and NEVER rename it: every QR already printed points here.
  APP_DOWNLOAD: '/app',
  CAREERS: '/careers',
  CORPORATE: '/corporate',

  // ── Pages the v5 reference's header and footer link to that we have
  //    not built yet ─────────────────────────────────────────────────────
  // They are declared here, and routed to <PagePending /> in AppRoutes, so
  // the chrome can carry its full link set without any entry dead-ending on
  // the catch-all redirect to Home. Each one gets swapped for the real page
  // as we work through the reference page by page; the constant and the URL
  // do not change when that happens, so nothing has to be re-pointed.
  PARTNERS: '/partners',
  PARTNER_DOCTORS: '/partners/doctors',
  PARTNER_LABS: '/partners/labs',
  PARTNER_MANAGED_LABS: '/partners/managed-labs',
  PARTNER_PHLEBOS: '/partners/phlebotomists',
  FRANCHISE: '/franchise',
  // The reference passes the city as a query param (`?city=…`) rather than
  // a path segment, and links to the bare page as a chooser. Kept as-is.
  CITY: '/city',
  BUILD_PACKAGE: '/build-package',
  DOCTOR_CONSULT: '/doctor-consult',
  CART: '/cart',
  BOOKING: '/booking',
  CANCEL_BOOKING: '/booking/:id/cancel',
  TRACK: '/track',
  LOGIN: '/login',
  SIGNUP: '/signup',
  REPORTS: '/reports',
  MY_TICKETS: '/my-tickets',
  DASHBOARD: '/dashboard',
  MED_DASHBOARD: '/portal/medical',
  LAB_DASHBOARD: '/portal/lab',
  CORP_DASHBOARD: '/portal/corporate',
  QA_PORTAL: '/portal/qa',
  ADMIN: '/portal/admin',
  SITE_ADMIN: '/site-admin',
};

// Helper for navigation with params
export const buildRoute = (route, params = {}) => {
  let path = route;
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value);
  });
  return path;
};
